import './App.css';
import React, { } from 'react';


function App() {


  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <img src={process.env.PUBLIC_URL + '/ms-icon-310x310.png'} alt="Parnana" />
    </div>
  )
}

export default App;
